import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ErrorPageComponent } from './error-page.component';
import { WelcomeFooterComponent } from './welcome-footer.component';
import { AccountSidebarComponent } from './components/account-sidebar/account-sidebar.component';
import { SharedModule } from 'shared/shared.module';
import { SettingsPage, HotkeyListPage } from './pages';
import { HotkeyInfoService } from './services/hotkey-info-service';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [
    AccountSidebarComponent,
    SettingsPage,
    ErrorPageComponent,
    WelcomeFooterComponent,
    HotkeyListPage
  ],
  providers: [HotkeyInfoService]
})
export class AccountModule {}
